

import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../ShipmentSelectScanType.css";
import { ToastContainer, toast } from "react-toastify";
import "jspdf-autotable";

import { UserContext } from "../../common/UserContext";
import config from "../../../envconfig";
import Select from "react-select";
import { IoCaretDownOutline, IoCaretUpOutline } from "react-icons/io5";

function ShipOutReturnScan() {
  const {
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
  } = useContext(UserContext);

  const { SHPR_ShipmentID } = useParams();
  const navigate = useNavigate();
  const [RSN, setRSN] = useState("");
  const [UniqueRSN, setUniqueRSN] = useState(new Set());
  const [SelectedShipmentID, setSelectedShipmentID] = useState(null);
  const [SelectedProductID, setSelectedProductID] = useState(null);
  const [ShipmentListShipmentID, setShipmentListShipmentID] = useState(null);
  const [CheckedItems, setCheckedItems] = useState(new Set());
  const [SCPNames, setSCPNames] = useState([]);
  const [ShipmentsBySCP, setShipmentsBySCP] = useState([]);
  const [SelectedProduct, setSelectedProduct] = useState("");
  const [ExtractedGTIN, setExtractedGTIN] = useState(null);
  const [selectedShipmentsBySCP, setSelectedShipmentsBySCP] = useState([]);
  const [ScannedResultForSCP, setScannedResultForSCP] = useState(null);
  const [shipRandomrsn, setShipRandomrsn] = useState({ getparentrsn: "" });
  const [fetchedData, setFetchedData] = useState("");
  const [notAddedValues, setNotAddedValues] = useState([]);
  const [isRSNScanned, setIsRSNScanned] = useState(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false); // Step 1: Track button click state
  const [manualInputEnabled, setManualInputEnabled] = useState(false);
  const [inputMode, setInputMode] = useState("scan"); // "scan" or "manual"
  const inputRef = useRef(null); // Add useRef to reference the input element
  const debounceTimer = useRef(null);
  // ========================== Log File ===============================
  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: `Shipment Outward Scanning By Vendor :`,
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };
  //====================================================================
//=======================================  
const [refreshTrigger, setRefreshTrigger] = useState(0);

const [rsnTree, setRsnTree] = useState(null);
const [expandedNodes, setExpandedNodes] = useState(new Set());

const renderRSNNode = (node, level = 0, isRoot = false, insideBox = false) => {
  const hasChildren = node.children && node.children.length > 0;
  const isExpanded = expandedNodes.has(node.IRS_RandomNo);

  return (
    <div key={node.IRS_RandomNo} style={{ marginLeft: level * 20 }}>
      {/* Root Node */}
      {isRoot ? (
        <>
          <input
            className="form-check-input"
            type="checkbox"
            checked={CheckedItems.has(node.IRS_RandomNo)}
            onChange={(e) => handleCheckBoxChange(e, node.IRS_RandomNo)}
            value={node.IRS_RandomNo}
            id={`check-${node.IRS_RandomNo}`}
          />
          <label
            className="form-check-label"
            htmlFor={`check-${node.IRS_RandomNo}`}
            style={{ color: "#465a64", marginLeft: "6px" }}
          >
            {node.IRS_RandomNo}
          </label>

          {/* Expand/Collapse button for root */}
          {hasChildren && (
            <button
              type="button"
              className="btn btn-link btn-sm"
              style={{ fontSize: "12px", padding: "2px 6px", marginLeft: "6px" }}
              onClick={() => {
                const newExpanded = new Set(expandedNodes);
                if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
                else newExpanded.add(node.IRS_RandomNo);
                setExpandedNodes(newExpanded);
              }}
            >
              {isExpanded ? "➖" : "➕"}
            </button>
          )}
        </>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Always reserve space for expand/collapse if inside box */}
          {insideBox && (
            <div style={{ width: "18px", textAlign: "center" }}>
              {hasChildren ? (
                <button
                  type="button"
                  className="btn btn-link btn-sm"
                  style={{
                    fontSize: "12px",
                    padding: "1px 3px",
                    lineHeight: "1",
                  }}
                  onClick={() => {
                    const newExpanded = new Set(expandedNodes);
                    if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
                    else newExpanded.add(node.IRS_RandomNo);
                    setExpandedNodes(newExpanded);
                  }}
                >
                  {isExpanded ? "➖" : "➕"}
                </button>
              ) : (
                <span style={{ display: "inline-block", width: "12px" }} />
              )}
            </div>
          )}

          {/* Label */}
          <span style={{ color: "#465a64", marginLeft: "6px" }}>
            {node.IRS_RandomNo}
          </span>
        </div>
      )}

      {/* Children */}
      {hasChildren && isExpanded && (
        <div
          style={{
            marginTop: 6,
            border: isRoot ? "1px solid #ccc" : "none",
            borderRadius: isRoot ? "6px" : "0",
            padding: isRoot ? "10px" : "0",
          }}
        >
          {node.children.map((child) =>
            renderRSNNode(child, level + 1, child.isRoot, true) // insideBox = true
          )}
        </div>
      )}
    </div>
  );
};

  //============================= Audit Trail ==========================
  const audittransection = async (data) => {
    const formData = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTR_NewValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName,
    };
    try {
      const response = await axios.post(
        `${config.API_URL}/api/audittransaction`,
        formData
      );
      // alert('Data inserted successfully');
    } catch (error) {
      if (error.response) {
        console.error("Server responded with an error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up the request:", error.message);
      }
    }
  };

  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    if (
      UM_CompanyID === null ||
      UM_CompanyID === "null" ||
      UM_CompanyGrpID === null ||
      UM_CompanyGrpID === "null" ||
      selectedScpId === null ||
      selectedScpId === "null"
    ) {
      console.log("null--------");
      const data = {
        AUTR_ScreenName: "Shipment Outward Scanning",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: null,
        AUTR_CompanyGrpId: null,
        AUTR_CompanyID: null,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };
      console.log(data);
      try {
        const response = await axios.post(
          `${config.API_URL}/api/audittrail`,
          data
        );
        console.log("Success:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      console.log("null--------");
      const data = {
        AUTR_ScreenName: "Shipment Outward Scanning",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: selectedScpId,
        AUTR_CompanyGrpId: UM_CompanyID,
        AUTR_CompanyID: UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };
      console.log(data);
      try {
        const response = await axios.post(
          `${config.API_URL}/api/audittrail`,
          data
        );
        console.log("Success:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  //====================================================================


  useEffect(() => {
  const fetchSCPNames = async () => {
    try {
      const response = await axios.get(
        `${config.API_URL}/SCP_Code_vendor_ReturnScan/${SHPR_ShipmentID}`
      );
      const data = response.data;
      if (response.status === 200) {
        const uniqueSCPNames = Array.from(
          new Set(
            data.SCPM_Name.map((scpName) => ({
              value: scpName.SCPM_Name,
              label: scpName.SCPM_Name,
            }))
          )
        );
        setSCPNames(uniqueSCPNames);

        // Auto-select the first SCP from the dropdown
        if (uniqueSCPNames.length > 0 && !SelectedProduct) {
          const firstSCP = uniqueSCPNames[0];
          setSelectedProduct(firstSCP.value);
          
        }
      } else {
        console.error("Error fetching SCP Names:", data.error);
        toast.error("Failed to fetch SCP Names");
      }
    } catch (error) {
      console.error("Failed to fetch SCP Names:", error);
      toast.error("Failed to fetch SCP Names");
    }
  };

  fetchSCPNames();
}, [SHPR_ShipmentID]);  
// Add this helper function for auto-selection logic
const handleAutoSCPSelection = (selectedProductValue) => {
  if (selectedProductValue && ShipmentsBySCP.length > 0) {
    const filteredShipmentsBySCP = ShipmentsBySCP.filter(
      (shipment) => shipment.SCPM_Name === selectedProductValue
    );

    const existingSCPIds = new Set(selectedShipmentsBySCP.map(item => `${item.SCPM_Name}-${item.SHPDR_ProductCode}`));
    const newItems = filteredShipmentsBySCP.filter(item => 
      !existingSCPIds.has(`${item.SCPM_Name}-${item.SHPDR_ProductCode}`)
    );
    
    if (newItems.length > 0) {
      setSelectedShipmentsBySCP((prevShipmentsBySCP) => [
        ...prevShipmentsBySCP,
        ...newItems,
      ]);
      const updatedData = [...selectedShipmentsBySCP, ...newItems];
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedData));
    }
  }

  // Update SCPNames to mark as disabled
  setSCPNames((prevSCPNames) =>
    prevSCPNames.map((option) =>
      option.value === selectedProductValue
        ? { ...option, isDisabled: true }
        : option
    )
  );

  setManualInputEnabled(false);
};
  //====================================================================

  useEffect(() => {
    const fetchAllData = async () => {
      try {
//========== Newly Added ============
      const storedData = sessionStorage.getItem('shipmentTable');
       if (storedData) {
        const parsedData = JSON.parse(storedData);
        setSelectedShipmentsBySCP(parsedData);
        return; 
       }
//===================================
        // Fetch data from Shipmentlist_vendor API
        const shipmentResponse = await axios.get(
          `${config.API_URL}/shipmentreturnlist_vendor_ReturnScan/${SHPR_ShipmentID}`
        );
        const shipmentData = shipmentResponse.data.shipmentData;
        logAction(`Shipment list fetched successfully`);
        // Fetch RSN PackSize data
        const scannedRSNResponse = await axios.get(
          `${config.API_URL}/Scanned_RSN_PackSize_OF_Shipment_Outward_ReturnScan/${SHPR_ShipmentID}/${selectedScpId}`
        );
        const rsnPackSizeData = scannedRSNResponse.data.AllRSN_ToOutward;

        const scannedRandomNoResponse = await axios.get(
          `${config.API_URL}/Scanned_RSN_OF_Shipment_Outward_ReturnScan/${SHPR_ShipmentID}/${selectedScpId}`
        );
        const rsnRandomNoData = scannedRandomNoResponse.data.AllRSN_ToOutward;
        const shipmentMap = {};
        shipmentData.forEach((shipment) => {
          const matchedRSN = rsnPackSizeData.find(
            (rsn) =>
              rsn.PL_ProductCode === shipment.SHPDR_ProductCode &&
              rsn.IRS_ToSCP === shipment.SHPDR_SCPCode
          );
          const key = `${shipment.SHPDR_ProductCode}-${shipment.SHPDR_SCPCode}`;
          if (!shipmentMap[key]) {
            shipmentMap[key] = {
              ...shipment,
              SHPDR_ShipQty: shipment.SHPDR_ShipQty,
              SHPDR_ScanQty: matchedRSN
                ? shipment.SHPDR_ScanQty + matchedRSN.IRS_PackSize
                : shipment.SHPDR_ScanQty,
            };
          } else {
            shipmentMap[key].SHPDR_ShipQty += shipment.SHPDR_ShipQty;
            shipmentMap[key].SHPDR_ScanQty += shipment.SHPDR_ScanQty;
          }
        });

        const mergedData = Object.values(shipmentMap);
        setShipmentsBySCP(mergedData);
          const rsnTreeDataRaw = await Promise.all(
            rsnRandomNoData.map(async (rsn) => {
              const resp = await axios.get(
                `${config.API_URL}/RSNChainToMap/${rsn.IRS_RandomNo}`
              );
              return resp.data.data; // recursive tree from backend
            })
          );
          
          // 🔥 Deduplicate by IRS_RandomNo
          const uniqueTreeData = [];
          const seen = new Set();
          for (const node of rsnTreeDataRaw) {
            if (!seen.has(node.IRS_RandomNo)) {
              seen.add(node.IRS_RandomNo);
              uniqueTreeData.push(node);
            }
          }
          
          setRsnTree(uniqueTreeData); 
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };
    if (selectedScpId) {
      fetchAllData();
    }
  }, [SHPR_ShipmentID, selectedScpId, refreshTrigger]);

  //====================================================================
//====================================================================

// ADD THIS NEW USEEFFECT HOOK FOR AUTO-SELECTION
useEffect(() => {
  if (selectedShipmentsBySCP.length > 0) {
    // If nothing is selected, auto-select the first available product
    if (!SelectedShipmentID && !SelectedProductID) {
      const firstAvailableProduct = selectedShipmentsBySCP.find(
        shipment => shipment.SHPDR_ShipQty > shipment.SHPDR_ScanQty
      );
      
      if (firstAvailableProduct) {
        setSelectedShipmentID(firstAvailableProduct.SHPDR_ShipmentMID);
        setSelectedProductID(firstAvailableProduct.PL_ProductId);
        setShipmentListShipmentID(firstAvailableProduct.SHPH_ShipmentID);
        console.log("Auto-selected first product:", {
          shipmentId: firstAvailableProduct.SHPDR_ShipmentMID,
          productId: firstAvailableProduct.PL_ProductId,
          productName: firstAvailableProduct.SHPDR_ProductName
        });
      }
    } 
    // Auto-switch to next available product when current one is saved
    else {
      const currentShipment = selectedShipmentsBySCP.find(
        shipment => shipment.SHPDR_ShipmentMID === SelectedShipmentID
      );
      
      if (currentShipment && currentShipment.SHPDR_ShipQty === currentShipment.SHPDR_ScanQty) {
        const nextAvailableProduct = selectedShipmentsBySCP.find(
          shipment => 
            shipment.SHPDR_ShipQty > shipment.SHPDR_ScanQty && 
            shipment.SHPDR_ShipmentMID !== SelectedShipmentID
        );
        
        if (nextAvailableProduct) {
          setSelectedShipmentID(nextAvailableProduct.SHPDR_ShipmentMID);
          setSelectedProductID(nextAvailableProduct.PL_ProductId);
          setShipmentListShipmentID(nextAvailableProduct.SHPH_ShipmentID);
          console.log("Auto-switched to next product:", {
            shipmentId: nextAvailableProduct.SHPDR_ShipmentMID,
            productId: nextAvailableProduct.PL_ProductId,
            productName: nextAvailableProduct.SHPDR_ProductName
          });
          
        }
      }
    }
  }
}, [selectedShipmentsBySCP, SelectedShipmentID, SelectedProductID]);

//====================================================================
  //====================================================================
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [confirmationCallback, setConfirmationCallback] = useState(null);
  const [cancelCallback, setCancelCallback] = useState(null); // Cancel callback for "NO"
  const [message, setMessage] = useState("");
  const scannerInput = useRef("");

  const showPopup = (message, onConfirm, onCancel) => {
    setMessage(message);
    setConfirmationCallback(() => onConfirm);
    setCancelCallback(() => onCancel); // Assign cancel callback
    setPopupVisible(true);
  };

  const handlePopupConfirm = () => {
    if (confirmationCallback) confirmationCallback();
    setPopupVisible(false);
  };

  const handlePopupClose = () => {
    if (cancelCallback) cancelCallback(); // Run cancel callback if "NO" is clicked
    setPopupVisible(false);
  };

  //====================================================================

  const FetchVendorData = async (rsnValue , shipment) => {
    try {
      if (!shipRandomrsn.getparentrsn) {
        console.error("shipRandomrsn.getparentrsn is undefined");
        return;
      }
      if (SelectedShipmentID) {
        if (!ExtractedGTIN) {
        const RSNStatus = await fetch(
          `${config.API_URL}/RSN_Status_Outward_ReturnScan_NonGTIN/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}/${ShipmentListShipmentID}`
        );
        if (RSNStatus.ok) {
          const data = await RSNStatus.json();
          console.log("Fetched Data:", data);

          if (data.IRS_Status === 6) {
            const RES = await fetch(
              `${config.API_URL}/ChildRSN_Lock_Outward_ReturnScan/${data.IRS_RandomNo}`
            );
            if (RES.ok) {
              const data = await RES.json();
              console.log("Fetched Data:", data);
            } else {
              console.error("Error fetching the data");
            }
            const response = await fetch(
              `${config.API_URL}/ParentRSN_PackSize_Outward_ReturnScan/${data.IRS_RandomNo}`
            );
            if (response.ok) {
              const data = await response.json();
              console.log("Fetched Data from ParentRSN_PackSize:", data);
              setFetchedData(data.PL_ProductCode);
              if (data.IRS_ParentRandomNo) {
                // Show custom popup instead of window.confirm
                showPopup(
                  "Are you sure you want to disaggregate the Parent RSN ?",
                  async () => {
                    try {
                      const packSizeResponse = await fetch(
                        `${config.API_URL}/ParentRSN_Disaggregation_Outward_ReturnScan/${data.IRS_RandomNo}`
                      );
                      if (packSizeResponse.ok) {
                        const packSizeData = await packSizeResponse.json();
                        console.log(
                          "Fetched Data from ParentRSN_Disaggregation:",
                          packSizeData
                        );
                        setFetchedData(packSizeData.IRS_PackSize);
                        setShipRandomrsn(packSizeData);
                        HandleAddRSNinBox(
                          packSizeData.IRS_PackSize,
                          packSizeData.PL_ProductCode
                        );
                        logAction(
                          ` All The Parent RSN of  ${data.IRS_RandomNo} of Shipment ID : ${SHPR_ShipmentID} disaggrigated successfully`
                        );
                      } else {
                        console.error("Error fetching IRS_PackSize data");
                      }
                    } catch (error) {
                      console.error("Error fetching IRS_PackSize data:", error);
                    }
                  },
                  async () => {
                    // Call when NO is clicked in popup
                    console.log("NO clicked: running IRS Status update");
                    try {
                      const response = await fetch(
                        `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward_ReturnScan/${data.IRS_RandomNo}`,
                        { method: "PUT" }
                      );
                      if (response.ok) {
                        console.log(
                          `IRS_Status updated successfully for value '${data.IRS_RandomNo}'`
                        );
                      } else {
                        console.log(
                          `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
                        );
                      }
                    } catch (error) {
                      console.error("Error updating IRS_Status:", error);
                      console.log(
                        `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
                      );
                    }
                    setFetchedData("");
                    setScannedResultForSCP("");
                  }
                );
              } else {
                console.log(
                  "Setting IRS_PackSize directly:",
                  data.IRS_PackSize
                );
                setFetchedData(data.IRS_PackSize);
                setShipRandomrsn(data);
                HandleAddRSNinBox(data.IRS_PackSize, data.PL_ProductCode);
              }
            } else {
              console.error("Error fetching the data");
            }
          } 
          else if (data.IRS_Status === 22) {
            if (!isRSNScanned) {
              toast.warning("RSN already scanned");
              logAction(`RSN  ${data.IRS_RandomNo} already exist`);
              setScannedResultForSCP("");
              return;
            } else {
              console.log("RSN Scanned");
            }
          }
           else if (data.IRS_Status === 21) {
            if (!isRSNScanned) {
              toast.warning("Invalid RSN");
              logAction(`Invalid RSN ${data.IRS_RandomNo}`);
              return;
            } else {
              console.log("RSN Scanned");
            }
          }
        } else if (RSNStatus.status === 404) {
          if (!isRSNScanned) {
            toast.warning("Invalid RSN");
            console.log("invalid RSN");
            setScannedResultForSCP("");
            console.error("Error fetching the RSN Status: No data found");
            return;
          } else {
            console.log("RSN Scanned");
          }
        } else {
          setScannedResultForSCP("");
          console.error("Error fetching the RSN Status");
        } 
       } else {
  const RSNStatus = await fetch(
          `${config.API_URL}/RSN_Status_Outward_ReturnScan/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}/${ExtractedGTIN}/${ShipmentListShipmentID}`
        );
        if (RSNStatus.ok) {
          const data = await RSNStatus.json();
          console.log("Fetched Data:", data);

          if (data.IRS_Status === 6) {
            const RES = await fetch(
              `${config.API_URL}/ChildRSN_Lock_Outward_ReturnScan/${data.IRS_RandomNo}`
            );
            if (RES.ok) {
              const data = await RES.json();
              console.log("Fetched Data:", data);
            } else {
              console.error("Error fetching the data");
            }
            const response = await fetch(
              `${config.API_URL}/ParentRSN_PackSize_Outward_ReturnScan/${data.IRS_RandomNo}`
            );
            if (response.ok) {
              const data = await response.json();
              console.log("Fetched Data from ParentRSN_PackSize:", data);
              setFetchedData(data.PL_ProductCode);
              if (data.IRS_ParentRandomNo) {
                // Show custom popup instead of window.confirm
                showPopup(
                  "Are you sure you want to disaggregate the Parent RSN ?",
                  async () => {
                    try {
                      const packSizeResponse = await fetch(
                        `${config.API_URL}/ParentRSN_Disaggregation_Outward_ReturnScan/${data.IRS_RandomNo}`
                      );
                      if (packSizeResponse.ok) {
                        const packSizeData = await packSizeResponse.json();
                        console.log(
                          "Fetched Data from ParentRSN_Disaggregation:",
                          packSizeData
                        );
                        setFetchedData(packSizeData.IRS_PackSize);
                        setShipRandomrsn(packSizeData);
                        HandleAddRSNinBox(
                          packSizeData.IRS_PackSize,
                          packSizeData.PL_ProductCode
                        );
                        logAction(
                          ` All The Parent RSN of  ${data.IRS_RandomNo} of Shipment ID : ${SHPR_ShipmentID} disaggrigated successfully`
                        );
                      } else {
                        console.error("Error fetching IRS_PackSize data");
                      }
                    } catch (error) {
                      console.error("Error fetching IRS_PackSize data:", error);
                    }
                  },
                  async () => {
                    // Call when NO is clicked in popup
                    console.log("NO clicked: running IRS Status update");
                    try {
                      const response = await fetch(
                        `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward_ReturnScan/${data.IRS_RandomNo}`,
                        { method: "PUT" }
                      );
                      if (response.ok) {
                        console.log(
                          `IRS_Status updated successfully for value '${data.IRS_RandomNo}'`
                        );
                      } else {
                        console.log(
                          `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
                        );
                      }
                    } catch (error) {
                      console.error("Error updating IRS_Status:", error);
                      console.log(
                        `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
                      );
                    }
                    setFetchedData("");
                    setScannedResultForSCP("");
                  }
                );
              } else {
                console.log(
                  "Setting IRS_PackSize directly:",
                  data.IRS_PackSize
                );
                setFetchedData(data.IRS_PackSize);
                setShipRandomrsn(data);
                HandleAddRSNinBox(data.IRS_PackSize, data.PL_ProductCode);
              }
            } else {
              console.error("Error fetching the data");
            }
          } 
          else if (data.IRS_Status === 22) {
            if (!isRSNScanned) {
              toast.warning("RSN already scanned");
              logAction(`RSN  ${data.IRS_RandomNo} already exist`);
              setScannedResultForSCP("");
              return;
            } else {
              console.log("RSN Scanned");
            }
          }
           else if (data.IRS_Status === 21) {
            if (!isRSNScanned) {
              toast.warning("Invalid RSN");
              logAction(`Invalid RSN ${data.IRS_RandomNo}`);
              return;
            } else {
              console.log("RSN Scanned");
            }
          }
        } else if (RSNStatus.status === 404) {
          if (!isRSNScanned) {
            toast.warning("Invalid RSN");
            console.log("invalid RSN");
            setScannedResultForSCP("");
            console.error("Error fetching the RSN Status: No data found");
            return;
          } else {
            console.log("RSN Scanned");
          }
        } else {
          setScannedResultForSCP("");
          console.error("Error fetching the RSN Status");
        }
        }
      } else {
        toast.warning("Please Select a Product");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  //====================================================================

  const handleInputModeChange = (mode) => {
    setInputMode(mode);
    setManualInputEnabled(mode === "manual");
    setScannedResultForSCP(""); // Clear input field when switching mode
    logAction(`Manual RSN Entry selected`);
  };

  useEffect(() => {
    // Focus the input field whenever the inputMode changes
    if (inputRef.current) {
      inputRef.current.focus(); // Focus the input field
    }
    logAction(`Scanning RSN Entry selected`);
  }, [inputMode]);
  

  const handleManualSubmit = () => {
    if (inputMode === "manual" && ScannedResultForSCP) {
      FetchVendorData(ScannedResultForSCP);
      if (
        ScannedResultForSCP &&
        !RSN.split("\n").includes(ScannedResultForSCP)
      ) {
        // Append the new value to the RSN list with a new line
        setRSN((prevRSN) => prevRSN + "\n");
        // Clear the input field after submission
        setScannedResultForSCP("");
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0); // Ensure focus after state update
      }
    } else if (!ScannedResultForSCP || ScannedResultForSCP.trim() === "")  {
      toast.warning("Please Enter RSN");
    }
  };
//=============================================
// Use This IF the  
//============================================= 

const handleKeyDown = (e) => {
  if (!e.key.match(/^[\r\n\t]*$/)) {
    HandleScanChange(e); // Invoke your async handler
  }
};


  useEffect(() => {
    if (inputMode === "scan" && ScannedResultForSCP) {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      debounceTimer.current = setTimeout(() => {
        if (
          ScannedResultForSCP &&
          !RSN.split("\n").includes(ScannedResultForSCP)
        ) {
          setRSN((prevRSN) => prevRSN + "\n");
          setScannedResultForSCP("");
        }
        FetchVendorData(ScannedResultForSCP);
        setScannedResultForSCP("");
      }, 500); // 1 second delay
      return () => {
        if (debounceTimer.current) {
          clearTimeout(debounceTimer.current);
        }
      };
    }
  }, [ScannedResultForSCP, shipRandomrsn.getparentrsn, inputMode]);

  const HandleInputChange = async (e) => {
    const scannedValue = e.target.value;
    
    setScannedResultForSCP(scannedValue);
    setShipRandomrsn({ getparentrsn: scannedValue });
    setFetchedData("");
  };


let scanTimeout;

const HandleScanChange = (e) => {
  const scannedValue = e.target.value.trim();
  if (scanTimeout) clearTimeout(scanTimeout);

  scanTimeout = setTimeout(() => {

  // Match RSN: (21|00) followed by 8–25 alphanumeric characters until (01|10|17) or end
    const rsnMatch = scannedValue.match(/\((21|00)\)([A-Z0-9]{8,25})(?=\(01\)|\(10\)|\(17\)|$)/i);

    // Match GTIN: (01) followed by 8–25 digits
    const gtinMatch = scannedValue.match(/\(01\)(\d{8,25})/);

    let extractedRSN = "";
    let extractedGTIN = null;

    if (rsnMatch && /^[A-Z0-9]{8,25}$/.test(rsnMatch[2])) {
      extractedRSN = rsnMatch[2];
    } else if (/^[A-Z0-9]{8,25}$/i.test(scannedValue)) {
      extractedRSN = scannedValue;
    }

    if (gtinMatch && /^\d{8,25}$/.test(gtinMatch[1])) {
      extractedGTIN = gtinMatch[1];
    }
    if (extractedRSN) {
      setScannedResultForSCP(extractedRSN);
      setShipRandomrsn({ getparentrsn: extractedRSN });
      setFetchedData('');
      console.log(' Extracted RSN:', extractedRSN);
    } else {
      console.warn(' Invalid or corrupted RSN');
      setScannedResultForSCP('');
    }
if (extractedGTIN) {
      setExtractedGTIN(extractedGTIN);
      console.log("Extracted GTIN:", extractedGTIN);
    } else {
      setExtractedGTIN(null);
    }

 
    if (inputRef.current) inputRef.current.value = '';
  }, 50); // Delay ensures full scan arrives
};


  const preventPaste = (e) => {
    e.preventDefault();
  };

const HandleAddRSNinBox = async (packSize, productCode) => {
  if (ScannedResultForSCP && !UniqueRSN.has(ScannedResultForSCP)) {
    let found = false;
    let updatedProductShipment = [...selectedShipmentsBySCP];

    if (SelectedShipmentID && SelectedProductID) {
      updatedProductShipment = updatedProductShipment.map((shipment) => {
        if (
          shipment.SHPDR_ShipmentMID === SelectedShipmentID &&
          SelectedProductID === shipment.PL_ProductId
        ) {
          if (shipment.SHPDR_ScanQty + packSize > shipment.SHPDR_ShipQty) {
            toast.warning('Scanning limit reached');
            logAction(
              `Scan Quantity reached the limit please select another product`
            );
            return shipment;
          } else {
            found = true;
            return{
              ...shipment,
              SHPDR_ScanQty: shipment.SHPDR_ScanQty + packSize
            };
          }
        }
        return shipment;
      });
    } else {
      updatedProductShipment = updatedProductShipment.map((shipment) => {
        if (shipment.SHPDR_ProductCode === productCode) {
          if (shipment.SHPDR_ScanQty + packSize > shipment.SHPDR_ShipQty) {
            toast.warning('Scanning limit reached');
            logAction(
              'Scan Quantity reached the limit please select another product'
            );
            return shipment;
          } else {
            found = true;
            return {
              ...shipment,
              SHPDR_ScanQty: shipment.SHPDR_ScanQty + packSize
            };
          }
        }
        return shipment;
      });
    }
    if (found) {
      setRSN((prevContent) => {
        const updated = prevContent +ScannedResultForSCP + "\n";
        const uniqueLines = [...new Set(updated.split("\n").filter((l) => l.trim() !==""))];
        return uniqueLines.join("\n");
      });
      setScannedResultForSCP("");
      setUniqueRSN((prevSerials) => new Set(prevSerials.add(ScannedResultForSCP)));
      logAction(
        `RSN : ${ScannedResultForSCP} is Scanned For Shipment ID : ${SHPR_ShipmentID}`
      );
      await fetchShipmentRSNLockForChild(SelectedShipmentID);
      await fetchShipmentRSNLockForParentRSN(SelectedShipmentID);
      try {
        const resp = await axios.get(
          `${config.API_URL}/RSNChainToMap/${ScannedResultForSCP}`
        );
        const newChain = resp.data.data;

        setRsnTree((prevTree) => {
          if (!prevTree || prevTree.length === 0) return [newChain];
          const exists = prevTree.some(
            (root) => root.IRS_RandomNo === newChain.IRS_RandomNo
          );
          return exists ? prevTree : [...prevTree, newChain];
        });
      } catch (err) {
        console.error("Faild To fetch RSN chain for new RSN :", err);
      }
      setSelectedShipmentsBySCP(updatedProductShipment);
      // Update the session storage  with the updated shipents 
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedProductShipment));
    } else {
      setNotAddedValues((prevValues) => [...prevValues, ScannedResultForSCP]);
      await updateScannedIRSStatus();
    }
  } else if  (!ScannedResultForSCP) {
    await updateScannedIRSStatus();
  } else {
    await updateScannedIRSStatus();
  }
};



  const updateScannedIRSStatus = async () => {
    try {
      const response = await axios.put(
        `${config.API_URL}/Update_Bymistake_Scanned_RSN_ReturnScan/${ScannedResultForSCP}`
      );
      if (response.status === 200) {
        console.log(
          `IRS_Status updated successfully for value '${ScannedResultForSCP}'`
        );
      } else {
        console.log(
          `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
        );
      }
    } catch (error) {
      console.error("Error updating IRS_Status:", error);
      console.error(
        `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
      );
    }
  };
  useEffect(() => {
    const updateIRSStatus = async () => {
      try {
        for (const value of notAddedValues) {
          const response = await axios.put(
            `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward_ReturnScan/${value}`
          );
          if (response.status === 200) {
            console.log(
              `IRS_Status updated successfully for value '${ScannedResultForSCP}'`
            );
          } else {
            console.log(
              `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
            );
          }
        }
        // Clear notAddedValues after updating IRS_Status for all values
        setNotAddedValues("");
      } catch (error) {
        console.error("Error updating IRS_Status:", error);
      }
    };
    // Call the updateIRSStatus function when notAddedValues changes
    if (notAddedValues.length > 0) {
      updateIRSStatus();
    }
  }, [notAddedValues]);

  const handleCheckBoxChange = (e, item) => {
    if (e.target.checked) {
      setCheckedItems((prevCheckedItems) =>
        new Set(prevCheckedItems).add(item)
      );
    } else {
      const newCheckedItems = new Set(CheckedItems);
      newCheckedItems.delete(item);
      setCheckedItems(newCheckedItems);
      sessionStorage.removeItem("RSN");
      sessionStorage.removeItem("CheckedItems");
    }
  };

  // Handle "Select All" functionality
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      // Select all items
        let allItems = new Set();

    // 1. Include all RSNs from textarea
    RSN.split("\n")
      .filter((line) => line.trim() !== "")
      .forEach((line) => allItems.add(line));

    // 2. Include all root + children from rsnTree
    const collectAllNodes = (node) => {
      allItems.add(node.IRS_RandomNo);
      if (node.children && node.children.length > 0) {
        node.children.forEach(collectAllNodes);
      }
    };
    if (rsnTree) {
      rsnTree.forEach(collectAllNodes);
    }
    setCheckedItems(allItems);
    } else {
      // Deselect all items
      setCheckedItems(new Set());
    }
  };


const handleSCPChange = async (selectedOption) => {
  const selectedProduct = selectedOption?.value;
  setSelectedProduct(selectedProduct);
  handleAutoSCPSelection(selectedProduct);
};

// Add this useEffect to handle auto-selection after ShipmentsBySCP data is available
useEffect(() => {
  if (SelectedProduct && ShipmentsBySCP.length > 0) {
    // This will trigger the same logic as manual selection
    const filteredShipmentsBySCP = ShipmentsBySCP.filter(
      (shipment) => shipment.SCPM_Name === SelectedProduct
    );

    const existingSCPIds = new Set(selectedShipmentsBySCP.map(item => `${item.SCPM_Name}-${item.SHPDR_ProductCode}`));
    const newItems = filteredShipmentsBySCP.filter(item => 
      !existingSCPIds.has(`${item.SCPM_Name}-${item.SHPDR_ProductCode}`)
    );
    
    if (newItems.length > 0) {
      setSelectedShipmentsBySCP((prevShipmentsBySCP) => [
        ...prevShipmentsBySCP,
        ...newItems,
      ]);
      const updatedData = [...selectedShipmentsBySCP, ...newItems];
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedData));
    }

    // Mark as disabled in dropdown
    setSCPNames((prevSCPNames) =>
      prevSCPNames.map((option) =>
        option.value === SelectedProduct
          ? { ...option, isDisabled: true }
          : option
      )
    );
    
    setManualInputEnabled(false);
  }
}, [SelectedProduct, ShipmentsBySCP]);
  const removeSelectedItemsAndUpdateStatus = async () => {
    try {
      const selectedItems = Array.from(CheckedItems);
      // Check if there are any selected items
      if (selectedItems.length === 0) {
        toast.warn("Please select a minimum one serial number");
        logAction("Please select a minimum one serial number");
        return; // Exit if no items are selected
      }
      // Update the status
      const response = await axios.put(
        `${config.API_URL}/Update_Removed_RSN_Status_Outward_ReturnScan`,
        {
          IRS_RandomNos: selectedItems,
        }
      );

      if (response.status === 200) {
        console.log("IRS_Status updated successfully for the selected items");
        logAction(
          `IRS_Status updated successfully for the selected items ${selectedItems}`
        );

        const { packSizes } = response.data;
        const totalPackSizeByProduct = packSizes.reduce((acc, packSize) => {
          const { PL_ProductCode, IRS_PackSize, SHPDR_SCPCode } = packSize;
          const key = `${PL_ProductCode}-${SHPDR_SCPCode}`;
          acc[key] = (acc[key] || 0) + IRS_PackSize;
          return acc;
        }, {});

        const updatedShipments = selectedShipmentsBySCP.map((shipment) => {
          const key = `${shipment.SHPDR_ProductCode}-${shipment.SHPDR_SCPCode}`;
          const totalPackSize = totalPackSizeByProduct[key] || 0;
          shipment.SHPDR_ScanQty = Math.max(
            0,
            shipment.SHPDR_ScanQty - totalPackSize
          ); // Ensure non-negative values
          return shipment;

        });


  setSelectedShipmentsBySCP(updatedShipments);
sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedShipments));
        await axios.post(`${config.API_URL}/ChildRSN_Status_OutwardScan_ReturnScan`, {
          IRS_RandomNos: selectedItems,
        });

       
           // --- Update RSN textarea ---
      const remainingRSN = RSN.split("\n")
        .map((line) => line.trim())
        .filter((line) => !selectedItems.includes(line)) // FIX: use selectedItems
        .join("\n");

      setRSN(remainingRSN.trim());

      // --- Update rsnTree (box UI) ---
      setRsnTree((prevTree) => {
        if (!prevTree) return prevTree;

        // Recursive child remover
        const removeNodes = (node) => {
          if (!node.children) return node;
          return {
            ...node,
            children: node.children
              .filter((child) => !selectedItems.includes(child.IRS_RandomNo))
              .map((child) => removeNodes(child)),
          };
        };

        // Remove roots + clean children
        return prevTree
          .filter((root) => !selectedItems.includes(root.IRS_RandomNo))
          .map((root) => removeNodes(root));
      });

        
        
        setCheckedItems(new Set()); 

        selectedItems.forEach((item) => {
          if (UniqueRSN.has(item)) {
            UniqueRSN.delete(item);
          }
        });

        toast.success(`Selected RSN removed successfully`);

        const selectAllCheckbox = document.getElementById("selectAll");
        if (selectAllCheckbox) {
          selectAllCheckbox.checked = false;
        }
        setRefreshTrigger((prev) => prev + 1);
        // Trigger a UI refresh
        document.getElementById("RSNInput")?.dispatchEvent(new Event("input"));
      } else {
        //console.error("Failed to update IRS_Status for the selected items");
      }
    } catch (error) {
      console.error("Error updating IRS_Status:", error);
    }
  };
  

  const updateScanQuantity = async (shipment) => {
    const {
      SHPDR_ShipmentID,
      SHPDR_ProductCode,
      SHPDR_ScanQty,
      SHPR_ShipmentReturnCode,
    } = shipment;

    try {
      // Step 1: Update scan quantity
      const updateScanResponse = await axios.put(
        `${config.API_URL}/Update_Scanqty_Outward_ReturnScan`,
        {
          SHPDR_ShipmentID,
          SHPDR_ProductCode,
        }
      );

      if (updateScanResponse.status !== 200) {
        console.log(
          `Failed to update scan quantity for Shipment ID ${SHPDR_ProductCode}`
        );
        logAction(
          `Failed to update scan quantity for Shipment ID ${SHPDR_ProductCode}`
        );
        return;
      }
      //======================================
      //======================================
      console.log("Function is called");
      const details = {
        AUTR_Message: `Shipment ${SHPR_ShipmentReturnCode} Completed`,
        AUTR_AuditType: "insert",
        AUTR_NewValue: "",
        AUTR_OldValue: "-",
      };
      let id = await audittrailpost(details);

      const logAuditTrail = (message, id, newValue, oldValue) => {
        const details = {
          AUTRN_ParamererName: message,
          AUTRN_ID: id,
          AUTRN_NewValue: newValue,
          AUTRN_OldValue: oldValue,
        };
        audittransection(details);
      };

      logAuditTrail("Shipment ", id, SHPR_ShipmentReturnCode, "-");
      console.log("Function is called ");
      //========================================
      //========================================
      const { SHPR_FromSCPCode, PL_ProductId } =
        updateScanResponse.data.updatedData;

      const inventoryResponse = await axios.get(
        `${config.API_URL}/Inventory_Outward_ReturnScanGET/${SHPR_FromSCPCode}/${PL_ProductId}`
      );

      if (inventoryResponse.status !== 200) {
        console.log(
          `Failed to fetch inventory data for SCPID ${SHPR_FromSCPCode} and Product ID ${PL_ProductId}`
        );
        return;
      }

      const inventoryData = inventoryResponse.data.inventorydata[0];
      const { inv_blockqty, inv_availableqty } = inventoryData;

      const updatedBlockQty = inv_blockqty - SHPDR_ScanQty;
      const updatedAvailableQty = inv_availableqty - SHPDR_ScanQty;

      const updateInventoryResponse = await axios.put(
        `${config.API_URL}/Inventory_Outward_ReturnScanPUT/${SHPR_FromSCPCode}/${PL_ProductId}`,
        {
          inv_blockqty: updatedBlockQty,
          inv_availableqty: updatedAvailableQty,
        }
      );

      if (updateInventoryResponse.status !== 200) {
        
        console.log(
          `Failed to update inventory for SCPID ${SHPR_FromSCPCode} and Product ID ${PL_ProductId}`
        );
        return;
      }
       toast.success(`Shipment : ${SHPR_ShipmentReturnCode} saved successfully.`, {
        toastId: `shipment-${SHPDR_ShipmentID}`,
      });
      logAction(`Shipment : ${SHPR_ShipmentReturnCode} saved successfully.`);

      setTimeout(() => {
        navigate("/ShipOutScanPendingList");
      }, 2000);
    } catch (error) {
      console.error(
        `Error processing request for Shipment ID ${SHPDR_ShipmentID}:`,
        error
      );
      toast.error(
        `Failed to process request for Shipment  ${SHPR_ShipmentReturnCode}`
      );
      logAction(`Failed to process request for Shipment  ${SHPR_ShipmentReturnCode}`);
    }
  };

  // ==================== Used For Shipment Lock =========================
  const fetchShipmentRSNLockForChild = async (SelectedShipmentID) => {
    try {
      const response = await axios.get(
        `${config.API_URL}/ShipmentData_For_RSN_Outward_ReturnScan/${SelectedShipmentID}/${SHPR_ShipmentID}`
      );
      const shipmentData = response.data.ShipmentForRSN;
      console.log("Shipment Data:", shipmentData);
      for (const item of shipmentData) {
        await axios.put(
          `${config.API_URL}/ChildRSNLockToShipMentID_Outward_ReturnScan/${shipRandomrsn.getparentrsn}`,
          {
            IRS_ShipmentID: item.IRS_ShipmentID,
            IRS_ToSCP: item.IRS_ToSCP,
            IRS_PhysicalLocation: item.IRS_PhysicalLocation,
          }
        );
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  };

  const fetchShipmentRSNLockForParentRSN = async (SelectedShipmentID) => {
    try {
      const response = await axios.get(
        `${config.API_URL}/ShipmentData_For_RSN_Outward_ReturnScan/${SelectedShipmentID}/${SHPR_ShipmentID}`
      );
      const shipmentData = response.data.ShipmentForRSN;
      console.log("Shipment Data:", shipmentData);

      for (const item of shipmentData) {
        await axios.put(
          `${config.API_URL}/ParentRSNLockToShipMentID_Outward_ReturnScan/${shipRandomrsn.getparentrsn}`,
          {
            IRS_ShipmentID: item.IRS_ShipmentID,
            IRS_ToSCP: item.IRS_ToSCP,
            IRS_PhysicalLocation: item.IRS_PhysicalLocation,
          }
        );
        const packSizeResponse = await axios.get(
          `${config.API_URL}/ParentRSN_Lock_Update_Outward_ReturnScan/${shipRandomrsn.getparentrsn}/${item.IRS_ShipmentID}/${item.IRS_ToSCP}`
        );

        if (packSizeResponse.status === 200) {
          const packSizeData = packSizeResponse.data;
          console.log(
            "Fetched Data from ParentRSN_Disaggregation:",
            packSizeData
          );
          //=======================//===================//===============//
          const parentRSNResponse = await fetch(
            `${config.API_URL}/Disaggrigated_RSN_History_Outward_ReturnScan`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                IRS_RandomNo: shipRandomrsn.getparentrsn,
              }),
            }
          );
          const parentRSNData = await parentRSNResponse.json();
          if (parentRSNResponse.ok && parentRSNData.IRS_ParentRandomNo) {
            const parentRandomNo = parentRSNData.IRS_ParentRandomNo;
            logAction(
              `The Parent RSN : ${parentRandomNo.join(", ")} of RSN ${
                shipRandomrsn.getparentrsn
              } of Shipment ID : ${SHPR_ShipmentID} Disaggregated Successfully`
            );
          }
          //=======================//===================//===============//

          console.log(
            "ShipmentID",
            item.IRS_ShipmentID,
            "SHPD SCP ID",
            item.IRS_ToSCP
          );
        } else {
          console.error("Error fetching IRS_PackSize data");
        }
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  };


  
  const [saveCallCount, setSaveCallCount] = useState(0); // Initialize call count state
  const handleSave = async (e) => {
    e.preventDefault();
    if (saveCallCount > 0) {
      console.log("handleSave function already called, ignoring subsequent calls.");
      return; // Disable further execution
    }
    // Increase the call count
    setSaveCallCount((prevCount) => prevCount + 1);
    try {
      for (const shipment of selectedShipmentsBySCP) {
        await updateScanQuantity(shipment);
      }
      await callInsertIRSInfoAPI();
      console.log("Shipment Outward Scanning Completed");
    } catch (error) {
      console.error("Error updating scan quantities:", error);
      toast.error("Failed to complete the shipment");
      setSaveCallCount(0);
    }
  };
  //==========================================================
  const callInsertIRSInfoAPI = async () => {

  const textareaRSNs = Array.from(
    new Set(RSN.split("\n").filter((line) => line.trim() !== ""))
  );
  
  // Collect RSNs from rsnTree (including all children)
  const treeRSNs = [];
  const collectAllNodes = (node) => {
    treeRSNs.push(node.IRS_RandomNo);
    if (node.children && node.children.length > 0) {
      node.children.forEach(collectAllNodes);
    }
  };
  
  if (rsnTree) {
    rsnTree.forEach(collectAllNodes);
  }

const allRSNValues = Array.from(new Set([...textareaRSNs, ...treeRSNs]));


    if (allRSNValues.length === 0) {
      console.log("No RSNs available to insert.");
      return;
    }


    console.log("Calling IRS info API with RSNs:", allRSNValues);
    try {
      const response = await axios.post(
        `${config.API_URL}/All_RSN_History_Insertion_Outward_ReturnScan`,
        {
          IRS_RandomNos: allRSNValues, // Send all RSNs to the API
        }
      );
      if (response.status === 200) {
        console.log(
          "Data successfully inserted into rsnhistoryinfo:",
          response.data
        );

        const RackSpace = await axios.get(
          `${config.API_URL}/RackSpace_Shipment_Outward_ReturnScan/${SHPR_ShipmentID}/${selectedScpId}`
        );
        if (RackSpace.status === 200) {
          console.log(`Logical Location updated successfully `);
        } else {
          console.log(`Failed to update Logical Location `);
        }

        logAction("IRS info inserted successfully");
      } else {
        console.log("Failed to insert IRS info:", response);
      }
    } catch (error) {
      console.error("Error inserting IRS info:", error);
      logAction("Failed to insert IRS info");
    }
  };

  const isSaveButtonVisible = () => {
    return selectedShipmentsBySCP.every(
      (shipment) => shipment.SHPDR_ShipQty === shipment.SHPDR_ScanQty
    );
  };
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
    // logAction(`Select opened: ${selectName}`);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
    // logAction("Select closed");
  };

const handleRowClick = (shipment) => {
  // Save clicked shipment + product info in state
 setSelectedShipmentID(shipment.SHPDR_ShipmentMID)
  setSelectedProductID(shipment.PL_ProductId)
  setShipmentListShipmentID(shipment.SHPH_ShipmentID)

  console.log("Row clicked →", {
    shipmentId: shipment.SHPDR_ShipmentMID,
    productId: shipment.PL_ProductId,
    productCode: shipment.SHPDR_ProductCode,
    productName: shipment.SHPDR_ProductName,
  });

};


  return (
    <>
      {/* <Sto /> */}
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      <div className="main_container">
        <h4 className="formHeading"> Vendor wise scanning </h4>
        <div className="">
          <div className="row">
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">SCP Name</label>
                <div className="select-container">
                  <Select
                    options={SCPNames}
                    value={SCPNames.find(
                      (option) => option.value === SelectedProduct
                    )}
                    onChange={handleSCPChange}
                    placeholder="Select SCP Name"
                    className="routing_select-box"
                    isSearchable
                    isOptionDisabled={(option) => option.isDisabled} // Disable already-selected options
                    styles={{
                      option: (base, state) => ({
                        ...base,
                        color: state.isDisabled ? "#999" : base.color,
                        backgroundColor: state.isDisabled
                          ? "#fff"
                          : base.backgroundColor,
                        cursor: state.isDisabled ? "not-allowed" : "default",
                      }),
                    }}
                    onMenuOpen={() => handleSelectOpen('scpName')}
                    onMenuClose={handleSelectClose}
                />
                <div className='icon-container'>
                    {isSelectOpen === 'scpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="mb-3">
                <div className="d-flex align-items-center">
                  <label
                    className="form-label"
                    style={{ marginBottom: "-5px" }}
                  >
                    RSN
                  </label>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginRight: "-25px",
                    }}
                  >
                    <input
                      type="radio"
                      name="inputMode"
                      value="manual"
                      checked={inputMode === "manual"}
                      onChange={() => handleInputModeChange("manual")}
                      style={{
                        accentColor: "black",
                        marginRight: "-25px",
                      }}
                    />
                    <label style={{ margin: "0" }}>Manual</label>
                  </div>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginRight: "-25px",
                    }}
                  >
                    <input
                      type="radio"
                      name="inputMode"
                      value="scan"
                      checked={inputMode === "scan"}
                      onChange={() => handleInputModeChange("scan")}
                      style={{
                        accentColor: "black",
                        marginRight: "-25px",
                      }}
                    />
                    <label style={{ margin: "0" }}>Scan</label>
                  </div>
                </div>

                {/* Manual Input Field */}
                {inputMode === "manual" && (
                  <div className="d-flex align-items-center mt-2">
                    <div
                      className="input-group"
                      style={{ flexGrow: 1, marginRight: "10px" }}
                    >
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter RSN"
                        ref={inputRef} // Use the inputRef to reference this input element
                        value={ScannedResultForSCP || ""}
                        onChange={HandleInputChange}
                        disabled={!SelectedProduct && !manualInputEnabled} // Disabled until product is selected or manual input is enabled
                        style={{ width: "100%" }}
                      />
                    </div>
                    <button
                      className="btn btn-dark"
                      onClick={handleManualSubmit}
                    >
                      SUBMIT
                    </button>
                  </div>
                )}

                {/* Scan Input Field */}
                {inputMode === "scan" && (
                  <div className="d-flex align-items-center mt-2">
                    <div
                      className="input-group"
                      style={{ flexGrow: 1, marginRight: "10px" }}
                    >
                   <input
                     type="text"
                     className="form-input"
                     placeholder="Scan RSN"
                     ref={inputRef}
                     defaultValue=""
                     onChange={HandleScanChange}
                     onPaste={preventPaste}
                     onKeyDown={handleKeyDown}
                     disabled={!SelectedProduct}
                     style={{ width: "100%" }}
                   />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-9">
            <div className="tableScanContainer">
              <table className="scantableClass">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th className="nav-tabs">SCP Name</th>
                    <th className="nav-tabs">Product Name </th>
                    <th className="nav-tabs">Product Code </th>
                    <th className="nav-tabs">Available Qty</th>
                    <th className="nav-tabs">Scanned Qty</th>
                    <th className="nav-tabs">Shipment Qty</th>
                  </tr>
                </thead>
                
                <tbody>
  {selectedShipmentsBySCP.map((shipment, index) => {
    const isSelected = SelectedShipmentID === shipment.SHPDR_ShipmentMID;
    const isCompleted = shipment.SHPDR_ShipQty === shipment.SHPDR_ScanQty;
    
    return (
      <tr
        key={shipment.SHPDR_ShipmentMID}
        onClick={() => handleRowClick(shipment)}
        className={
          isSelected 
            ? isCompleted ? "highlight" : "auto-highlight" 
            : ""
        }
        style={{
          cursor: isCompleted ? 'not-allowed' : 'pointer',
          opacity: isCompleted ? 0.6 : 1
        }}
      >
        <td>{index + 1}</td>
        <td>{shipment.SCPM_Name}</td>
        <td>{shipment.SHPDR_ProductName}</td>
        <td>{shipment.SHPDR_ProductCode}</td>
        <td>{shipment.inv_availableqty}</td>
        <td>{shipment.SHPDR_ScanQty}</td>
        <td>{shipment.SHPDR_ShipQty}</td>
      </tr>
    );
  })}
</tbody>
              </table>
              {SelectedProduct && selectedShipmentsBySCP.length === 0 && (
                <div>
                  No ShipmentsBySCP available for the selected SCPM_Name
                </div>
              )}
            </div>
          </div>

          <div className="col-md-3">
            <div className="scanContainer">
              <p className="scannedHeading">Scanned RSN List</p>
              <div>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="selectAll"
                  onChange={handleSelectAllChange}
                />
                <label className="form-check-label" htmlFor="selectAll">
                  Select All
                </label>
              </div>
              {[...new Set(RSN.split("\n").filter((line) => line.trim() !== ""))].map(
                 (line, index) => (
                   <div key={index}>
                     {/* <label>{line}</label> */}
                   </div>
                 )
               )}
             
               {/* Deduplicated RSN tree */}
               {rsnTree &&
                 rsnTree.map((rootNode) =>
                   renderRSNNode(rootNode, 0, rootNode.isRoot)
                 )}
             </div>
          </div>
          <div className="button-container mt-2">
            <button
              onClick={removeSelectedItemsAndUpdateStatus}
              className="scan_btn"
            >
              REMOVE SELECTED
            </button>
          </div>
        </div>
      </div>
      <div className="button-container">
        {isSaveButtonVisible() && (
          <button
            className="save_btn"
            onClick={handleSave}
            disabled={
              isSaveButtonDisabled || (!SelectedProduct && !manualInputEnabled)
            }
          >
            SAVE
          </button>
        )}

        {isPopupVisible && (
          <div className="popup-box">
            <div className="popup-content-Suspend">
              <h5 className="Suspend-Popup-Heading">:: User Confirmation ::</h5>
              <p className="Suspend-Popup-Text">{message}</p>
              <div>
                <button
                  className="button-Confirm-Popup"
                  onClick={handlePopupConfirm}
                >
                  YES
                </button>
                <button
                  className="button-Close-Popup"
                  onClick={handlePopupClose}
                >
                  NO
                </button>
              </div>
            </div>
          </div>
        )}
        <Link 
        to={`/ShipOutScanPendingList`} 
        className="back_btn" 
        type="button"
        onClick={() => sessionStorage.removeItem('shipmentTableData')}
        >
          LIST
        </Link>
      </div>
    </>
  );
}

export default ShipOutReturnScan;
